import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { toastFactory } from '@/factories'
import i18n from '@/i18n'
import { getApiErrorMessage, resetQueries } from '@/utils'

import { AMENITY_LOCATIONS_QUERY_KEY } from './get-amenity-locations'
import { RESERVATION_DETAILS_QUERY_KEY } from './get-reservation-details'
import { RESERVATION_TRANSACTIONS_QUERY_KEY } from './get-reservation-transactions'

export type ChangeReservationLocationRequest = {
  reservationId: number
  newLocationId: number | string
  notifyEmail?: boolean
  newLocationName?: string
}

export const changeReservationLocation = async ({
  reservationId,
  newLocationId,
  notifyEmail = false,
}: ChangeReservationLocationRequest) => {
  const { data } = await authAPI.patch(
    `/reservation/${reservationId}`,
    {
      locationId: newLocationId,
    },
    {
      params: {
        notifyEmail,
      },
    },
  )

  return data
}

export const useChangeReservationLocation = () => {
  return useMutation({
    mutationFn: changeReservationLocation,
    onError: (res) => {
      toastFactory.error(getApiErrorMessage(res))
    },
    onSuccess: async (_, variables) => {
      await resetQueries(
        [RESERVATION_DETAILS_QUERY_KEY],
        [RESERVATION_TRANSACTIONS_QUERY_KEY],
        [AMENITY_LOCATIONS_QUERY_KEY],
      )

      toastFactory.success(
        i18n.t('reservations:details.apiMessages.moveReservationLocationSuccess', {
          newLocationName: variables.newLocationName || '',
        }),
      )
    },
  })
}
